import { isSubscribedTo, messageStyle } from '../logger/logger.js';

const logPerf = (measurement, duration) => {
  if (!isSubscribedTo("perf")) {
    return;
  }
  const styles = [
    messageStyle("common"),
    "",
    messageStyle("perf"),
    "",
    `font-weight: bold;`
  ];
  console.log(`%c@guardian%c %c${measurement}%c %c${duration}ms`, ...styles);
};

export { logPerf };
